// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._6hRTqZW0x{box-sizing:border-box;margin:0}._1Yzh4qCSx{box-shadow:0 0 32px 0 rgba(0,0,0,0.06)}._6aCXllvXx{box-shadow:0 3px 6px 0 rgba(0,0,0,0.06)}@media screen and (-ms-high-contrast: active){._6aCXllvXx{border:1px solid windowText;box-sizing:border-box}}.xXXiVt8xx{color:var(--primary-text);display:block;font-size:14px;line-height:20px;margin-bottom:6px}._7uA9sy9fx{font-size:12px;color:var(--secondary-text);margin-top:5px;word-break:keep-all}.cK3auCoXx{height:80px;padding:20px;box-sizing:border-box;flex-shrink:0}._7oiohR3Dx{display:inline-block;margin:0 8px}._4Bs4L0f9x{color:var(--secondary-text);font-size:12px;line-height:20px;text-transform:uppercase}._62wriTp2x{font-size:14px;line-height:20px;color:var(--primary-text)}._29FyQa2Cx{pointer-events:none}._29FyQa2Cx>*{opacity:.4}@media screen and (-ms-high-contrast: active){._29FyQa2Cx{color:grayText}._29FyQa2Cx div[class^=\"gravatar-avatar\"]{background-color:grayText;border-radius:50%}._29FyQa2Cx img{opacity:.4}._29FyQa2Cx>*{opacity:1}}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"reset": "_6hRTqZW0x",
	"shadow-center": "_1Yzh4qCSx",
	"shadowCenter": "_1Yzh4qCSx",
	"shadow-down": "_6aCXllvXx",
	"shadowDown": "_6aCXllvXx",
	"label": "xXXiVt8xx",
	"form-desc": "_7uA9sy9fx",
	"formDesc": "_7uA9sy9fx",
	"bar": "cK3auCoXx",
	"bar-label-container": "_7oiohR3Dx",
	"barLabelContainer": "_7oiohR3Dx",
	"bar-label-label": "_4Bs4L0f9x",
	"barLabelLabel": "_4Bs4L0f9x",
	"bar-label-value": "_62wriTp2x",
	"barLabelValue": "_62wriTp2x",
	"disable-dim": "_29FyQa2Cx",
	"disableDim": "_29FyQa2Cx"
};
module.exports = exports;
